module.exports = __webpack_public_path__ + "static/media/3.bd93fa70.png";